import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { NamedLink } from '../../../components';

import css from './DealsTabs.module.css';

/**
 * The top of the Deals pages (Member Home design): the "Deals" title and the
 * tabs Explore · Saved searches · Favourites, each with its count.
 *
 *   Explore    - today's search page (the new All deals and filters are later)
 *   Saved searches - later (ACs: Needs Design); shown, not clickable yet
 *   Favourites - the favourites page
 */
export const DealsTabsComponent = props => {
  const { active, exploreCount, favouritesCount, className } = props;

  const count = (n, accent) =>
    typeof n === 'number' && n > 0 ? (
      <span className={classNames(css.count, { [css.countAccent]: accent })}>{n}</span>
    ) : null;

  return (
    <div className={classNames(css.root, className)}>
      <h1 className={css.title}>Deals</h1>
      <nav className={css.tabs} aria-label="Deals">
        <NamedLink
          name="SearchPage"
          className={classNames(css.tab, { [css.tabActive]: active === 'explore' })}
        >
          Explore
          {count(exploreCount)}
        </NamedLink>
        <span className={classNames(css.tab, css.tabSoon)} title="Coming soon" aria-disabled="true">
          Saved searches
          <span className={css.soon}>Soon</span>
        </span>
        <NamedLink
          name="FavoriteListingsPage"
          className={classNames(css.tab, { [css.tabActive]: active === 'favourites' })}
        >
          Favourites
          {count(favouritesCount)}
        </NamedLink>
      </nav>
    </div>
  );
};

const mapStateToProps = state => ({
  favouritesCount: (state.favoriteListings?.favoriteIds || []).length,
});

export default connect(mapStateToProps)(DealsTabsComponent);
